import React from 'react'
import { useAppDispatch, useAppSelector } from '@SonarCX/hooks/redux'

import SettingsPage from '../SettingsPage'
import NoPermissionContainer from '@SonarCX/components/molecules/NoPermissionContainer'
import SettingsSection from '../SettingsSection'
import InboxesTable from './InboxesTable'
import InboxesCards from './InboxesCards'
import Button from '@SonarCX/components/atoms/Button2'
import BaseInboxModal from '@SonarCX/components/molecules/ChatModals/BaseInboxModal'

import { selectBaseInbox, loadBaseInboxes } from '@SonarCX/slices/baseInbox'
import { useBreakpoint } from '@SonarCX/providers/BreakpointProvider'
import useStyles from './styles'

const InboxSettings = () => {
  const dispatch = useAppDispatch()
  const { loaded, error } = useAppSelector(selectBaseInbox)

  const { isExtraSmall } = useBreakpoint()

  const [showModal, setShowModal] = React.useState(false)
  const [data, setData] = React.useState(null)

  const classes = useStyles()

  React.useEffect(() => {
    if (!loaded) {
      dispatch(loadBaseInboxes())
    }
  }, [loaded, dispatch])

  // Opens the modal
  const openModal = React.useCallback(
    data => () => {
      if (data) {
        setData(data)
      }
      setShowModal(true)
    },
    []
  )

  // Closes the modal
  const handleClose = React.useCallback(() => {
    setShowModal(false)
    setData(null)
  }, [])

  return (
    <SettingsPage title='Inboxes'>
      <NoPermissionContainer skipAgentPage error={error}>
        <SettingsSection title='Settings' loaded={loaded}>
          {isExtraSmall ? (
            <InboxesCards openModal={openModal} />
          ) : (
            <InboxesTable openModal={openModal} />
          )}

          <div className={classes.root}>
            <Button
              onClick={() => setShowModal(true)}
              className={classes.button}
            >
              CREATE INBOX
            </Button>
          </div>

          {showModal && <BaseInboxModal onClose={handleClose} data={data} />}
        </SettingsSection>
      </NoPermissionContainer>
    </SettingsPage>
  )
}

export default InboxSettings
